export function coerceTags(tags:{value:string}):Array<string> {
  return tags.value.split(' ').map(v => v.trim()).filter(v => !!v);
}
export function extractLocker(lock:unknown) {
  let locked = false;
  let lockerId = null;
  if(lock){
    locked = lock["locked"];
    const locker = lock["locker"];
    if(locker){
      lockerId =locker["id"].toString();
    }
  }
  return {
    locked,
    lockerId
  }
}